import styled from 'styled-components';

const BigButtonStyles = styled.div`
    background-color: darkorange;
    width: 125px; 
    position: absolute;
    right: -2px;
    top: -2px;
    text-align: center;
    font-size: 2rem;
    &:hover {
        cursor: pointer;
    }
`;

export default BigButtonStyles;